import { useState } from 'react'

import { colors } from '@zet/design-system'
import { Stack, XStack, YStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import CheckBox from '@zet/design-system/svg/CheckBox'
import CheckBoxTickFilled from '@zet/design-system/svg/CheckBoxTickFilled'

import { Note, state } from '../../utils/types'
import ActionButtons from './actionButtons'
import { ConsentContent } from './consentContent/index.web'
import Info from './info'

type Props = {
  Content: React.ReactNode
  state: state
  note?: Note
  buttons?: any[]
  consent?: string[]
  expiryTimeEpochInMillis?: number
  isLoading: boolean
  mutate: (...props: any) => void
}

export const StatusScreenWrapper: React.FC<Props> = ({
  Content,
  note,
  buttons,
  expiryTimeEpochInMillis,
  consent,
}) => {
  const [userConsentChecked, setUserConsentChecked] = useState(
    Array.from({ length: consent?.length || 0 }, () => true)
  )

  const changeUserConsent = (currentIndex: number, isChecked: boolean) => {
    setUserConsentChecked(
      userConsentChecked.map((value, index) =>
        index === currentIndex ? isChecked : value
      )
    )
  }
  return (
    <Stack className="flex-1">
      {Content}
      {!!(note?.localizationText || note?.text || note?.title) && (
        <Stack
          style={{
            marginTop: note?.position === 'bottom' ? 'auto' : 0,
          }}
        >
          <Info note={note} expiryTimeEpochInMillis={expiryTimeEpochInMillis} />
        </Stack>
      )}
      {!!buttons && (
        <YStack
          className="border-grays-40 border-t-2"
          style={{ marginTop: note?.position === 'bottom' ? '0' : 'auto' }}
        >
          {!!consent &&
            consent?.map((consent, index) => {
              return (
                <XStack className="px-3 py-2">
                  {userConsentChecked[index] ? (
                    <Pressable onPress={() => changeUserConsent(index, false)}>
                      <CheckBoxTickFilled
                        color={colors.primary[100]}
                        size={18}
                      />
                    </Pressable>
                  ) : (
                    <Pressable onPress={() => changeUserConsent(index, true)}>
                      <CheckBox color={colors.primary[100]} size={18} />
                    </Pressable>
                  )}
                  <Stack className="ml-1 flex-1">
                    <ConsentContent consentData={consent} index={index} />
                  </Stack>
                </XStack>
              )
            })}
          <ActionButtons buttons={buttons} />
        </YStack>
      )}
    </Stack>
  )
}
